import EnumsApiService from '@services/enums.api.service';

import { MutationTypes, ActionTypes } from './enums.types';

const generateEnumByKeyValue = (name) => ({ enums: { [name]: enumType } }) => (enumType || [])
  .reduce((acc, { key, value }) => {
    acc[value] = key;
    return acc;
  }, {});

export default {
  namespaced: true,
  state: {
    enums: {},
  },
  mutations: {
    [MutationTypes.SET_ENUMS](state, payload) {
      state.enums = payload;
    },
  },
  actions: {
    async [ActionTypes.GET_ENUMS]({ commit }) {
      commit(MutationTypes.SET_ENUMS, await EnumsApiService.getEnums());
    },
  },
  getters: {
    uvEnumByValue: generateEnumByKeyValue('uv'),
    irResultByValue: generateEnumByKeyValue('irResult'),
    boxTypeEnumByValue: generateEnumByKeyValue('boxType'),
    boxUnitEnumByValue: generateEnumByKeyValue('boxUnits'),
    orderStatusEnumByValue: generateEnumByKeyValue('orderStatus'),
    labelFormatsEnumByValue: generateEnumByKeyValue('labelFormats'),
    machinesStateEnumByValue: generateEnumByKeyValue('machineState'),
    productStatusEnumByValue: generateEnumByKeyValue('productStatus'),
    pressSheetSideEnumByValue: generateEnumByKeyValue('pressSheetSide'),
    orderItemStatusEnumByValue: generateEnumByKeyValue('orderItemStatus'),
    substrateStatusEnumByValue: generateEnumByKeyValue('substrateStatus'),
    transitionEventEnumByValue: generateEnumByKeyValue('transitionEvents'),
    pressSheetStatusEnumByValue: generateEnumByKeyValue('pressSheetStatus'),
    validationStatusEnumByValue: generateEnumByKeyValue('validationStatus'),
    inputMessageTypeEnumByValue: generateEnumByKeyValue('inputMessageType'),
    transitionActionEnumByValue: generateEnumByKeyValue('transitionActions'),
  },
};
